import { Router, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => {
      const auth = inject(AuthService);
      const router = inject(Router);
      // APP_INITIALIZER guarantees auth.ready() is true before routing starts
      return auth.isAuthenticated()
        ? router.parseUrl('/portal/home')
        : router.parseUrl('/auth/login');
    },
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'wizard',
    loadChildren: () => import('./features/wizard/wizard.routes').then((m) => m.wizardRoutes),
  },
  {
    path: 'portal',
    loadChildren: () => import('./features/portal/portal.routes').then((m) => m.portalRoutes),
  },
  { path: '**', redirectTo: 'auth/login' },
];
